// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3ES8K","title":"AfterBackImages_title__14Fpo","images":"AfterBackImages_images__1kFJ5"};